if (!customElements.get('zb-catalogue-reveal')) {
  customElements.define('zb-catalogue-reveal', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = [];
      this.setup = () => {
        this.observer?.disconnect();
        this.animations.forEach(animation => animation.cancel());
        this.animations = [];
        if (this.motion.matches || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.animations.push(entry.target.animate([{ opacity: .4, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 650, easing: 'cubic-bezier(.2,.65,.3,1)' }));
          this.observer.unobserve(entry.target);
        }), { threshold: .06 });
        this.querySelectorAll('[data-catalogue-reveal]').forEach(node => this.observer.observe(node));
      };
      this.motion.addEventListener('change', this.setup, { signal: this.abort.signal });
      this.setup();

    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
